import { handleActions } from 'redux-actions';
import * as R from 'ramda';

import {
  FETCH_TEAMS,
  FETCH_TEAM,
  UPDATE_TEAM,
  CREATE_TEAM,
  DELETE_TEAM,
  TEAMS_FILTER_SET,
  TEAMS_PAGE_SET,
  CURRENT_TEAM_RESET
} from '../../constants/Constants';

const initialState = { 
  items: [], 
  filter: null, 
  currentTeam: {}, 
  pagination: { page: 0, size: 50 } 
};

const COLLATOR = new Intl.Collator('cs');
const nameComparator = (a, b) => COLLATOR.compare(a.name, b.name);

export default handleActions(
  {
    [FETCH_TEAMS.SUCCESS]: (state, { payload: { items, page } }) => ({
      ...state,
      items: R.sortWith([nameComparator])(items),
      page
    }),
    [FETCH_TEAM.SUCCESS]: (state, { payload: { payload } }) => ({ 
      ...state, 
      currentTeam: payload 
    }),
    [UPDATE_TEAM.SUCCESS]: (state, { payload: { payload } }) => ({
      ...state,
      currentTeam: payload,
      currentTeamSaving: false
    }),
    [CREATE_TEAM.SUCCESS]: (state, { payload: { payload } }) => ({
      ...state,
      currentTeam: payload,
      currentTeamSaving: false
    }),
    [UPDATE_TEAM.PENDING]: state => ({ ...state, currentTeamSaving: true }),
    [CREATE_TEAM.PENDING]: state => ({ ...state, currentTeamSaving: true }),
    [TEAMS_FILTER_SET]: (state, { payload }) => ({ 
      ...state, 
      filter: payload,
      pagination: { ...state.pagination, page: 0 }
    }),
    [TEAMS_PAGE_SET]: (state, { payload: { page } }) => ({ 
      ...state, 
      pagination: { ...state.pagination, page } 
    }),
    [CURRENT_TEAM_RESET]: state => ({ ...state, currentTeam: {} })
  },
  initialState
); 


// WEBPACK FOOTER //
// ./src/reducers/entities/TeamsReducer.js